export default "__VITE_ASSET__KMd4qewt__"